import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import '../styles/ExpenseTypes.css';

const SupervisorExpenseTypes = () => {
  const [expenseTypes, setExpenseTypes] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const navigate = useNavigate();

  useEffect(() => {
    const fetchExpenseTypes = async () => {
      try {
        setLoading(true);
        const token = localStorage.getItem('token');
        
        if (!token) {
          navigate('/login');
          return;
        }
        
        const response = await axios.get('/api/supervisors/expense-types', {
          headers: {
            Authorization: `Bearer ${token}`
          }
        });
        
        // Asegurar que response.data sea un array
        const data = Array.isArray(response.data) ? response.data : [];
        setExpenseTypes(data);
      } catch (error) {
        console.error('Error fetching expense types:', error);
        console.error('Error response:', error.response?.data);
        setError('No se pudieron cargar los tipos de gastos. Por favor, inténtelo de nuevo.');
        
        // If unauthorized, redirect to login
        if (error.response && error.response.status === 401) {
          navigate('/login');
        }
      } finally {
        setLoading(false);
      }
    };

    fetchExpenseTypes();
  }, [navigate]);

  if (loading) {
    return <div className="loading">Cargando tipos de gastos...</div>;
  }

  return (
    <div className="dashboard-container">
      <header className="dashboard-header">
        <h1>Catálogo de Gastos</h1>
        <button onClick={() => navigate('/supervisor-dashboard')} className="back-btn">
          Volver al Dashboard
        </button>
      </header>

      <div className="expense-types-section">
        <div className="expense-types-section-header">
          <h2>Tipos de Gastos Registrados</h2>
        </div>

        {error && (
          <div className="error-message">
            {error}
          </div>
        )}

        <div className="expense-types-list">
          {expenseTypes.length === 0 ? (
            <p className="no-expense-types">No hay tipos de gastos registrados.</p>
          ) : (
            <table className="expense-types-table">
              <thead>
                <tr>
                  <th>Categoría</th>
                  <th>Nombre</th>
                  <th>Descripción</th>
                </tr>
              </thead>
              <tbody>
                {expenseTypes.map((expenseType, index) => (
                  <tr key={index}>
                    <td>{expenseType.categoria}</td>
                    <td>{expenseType.name}</td>
                    <td>{expenseType.description || 'Sin descripción'}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          )}
        </div>
      </div>
    </div>
  );
};

export default SupervisorExpenseTypes;
